import SectionHead from "./SectionHead";
import { meaningSteps } from "@/mocks/content";

export default function Meaning() {
  return (
    <section id="meaning" className="relative overflow-hidden bg-white py-16 md:py-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-10 h-56 w-56 rounded-full bg-emerald-50 blur-2xl"
      />
      <div className="relative mx-auto max-w-6xl px-4 md:px-6">
        <SectionHead
          eyebrow="02 · 含义拆解"
          title="一层层看懂“53吃瓜”"
          desc="这个词拆开看其实不复杂，我们按四层带你从“吃瓜”一路拆到“53吃瓜”，越拆越清楚。"
        />

        <ol className="mt-12 grid gap-6 md:grid-cols-2">
          {meaningSteps.map((s) => (
            <li
              key={s.step}
              className="group relative flex gap-5 rounded-3xl bg-[#fff8f0] p-7 ring-1 ring-orange-100 transition-transform hover:-translate-y-1"
            >
              <span
                aria-hidden="true"
                className="font-heading select-none text-5xl text-orange-200 transition-colors group-hover:text-rose-300"
              >
                {s.step}
              </span>
              <div>
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-rose-500 text-lg text-white">
                  <i className={s.icon} aria-hidden="true" />
                </div>
                <h3 className="mt-3 text-lg font-bold text-stone-800">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-stone-500">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 rounded-3xl bg-gradient-to-r from-rose-500 to-orange-400 p-7 text-white md:p-8">
          <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="font-heading text-2xl">一句话总结</p>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-rose-50">
                看到「53吃瓜」，你基本可以理解为：“这是热门话题的代号，我搬好板凳蹲后续。”
                不同社群指向可能不同，但那股“围观 + 跟进”的心情是相通的。
              </p>
            </div>
            <a
              href="#origin"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-white/95 px-5 py-2.5 text-sm font-medium text-rose-600 transition-colors hover:bg-white"
            >
              这个梗怎么来的
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}